module.exports = __webpack_public_path__ + "061c51ec571533c5aec55c7fb4d3d1b3.svg";